import { createContext, useContext, useState, ReactNode } from 'react';
import { WORKSPACES, type Workspace } from '@/shared/config/platform-config';

interface WorkspaceContextType {
  currentWorkspace: Workspace;
  workspaces: Workspace[];
  switchWorkspace: (workspaceId: string) => void;
}

const WorkspaceContext = createContext<WorkspaceContextType | undefined>(undefined);

export function WorkspaceProvider({ children }: { children: ReactNode }) {
  const defaultWs = WORKSPACES.find(w => w.isDefault) || WORKSPACES[0];
  const [currentWorkspace, setCurrentWorkspace] = useState<Workspace>(defaultWs);

  const switchWorkspace = (workspaceId: string) => {
    const ws = WORKSPACES.find(w => w.id === workspaceId);
    if (ws && ws.enabled) {
      setCurrentWorkspace(ws);
    }
  };

  return (
    <WorkspaceContext.Provider value={{
      currentWorkspace,
      workspaces: WORKSPACES,
      switchWorkspace,
    }}>
      {children}
    </WorkspaceContext.Provider>
  );
}

export function useWorkspace() {
  const context = useContext(WorkspaceContext);
  if (!context) {
    throw new Error('useWorkspace must be used within WorkspaceProvider');
  }
  return context;
}
